<script setup lang="ts">
import MaklervollmachtForm from "@/Maklervollmacht/components/MaklervollmachtForm.vue";
import BaseModal from '@/application/components/BaseModal.vue';

defineProps<{ show: boolean }>();
const emit = defineEmits(['update:show']);
</script>

<template>
  <BaseModal
    title="Maklervollmacht anfordern"
    :show="show"
    height="92%"
    @close="emit('update:show', false)"
  >
    <MaklervollmachtForm
      v-if="show"
      @success="emit('update:show', false)"
      @cancel="emit('update:show', false)"
    />
  </BaseModal>
</template>
